import type { TypeVatRate } from '@/types/commercial/types.commercial.fiscal';
import type { TypeExpenseCategory, TypeExpenseMethod, TypeExpenseRecurrence } from '@/types/expense/types.expense';

export const DEDUCTIBLE_DEFAULT: Record<TypeExpenseCategory, number> = {
    software: 100,
    hosting: 100,
    hardware: 100,
    phone: 80,
    training: 100,
    meals: 75,
    lodging: 75,
    transit: 100,
    taxi: 100,
    car: 20,
    representation: 100,
    office: 100,
    professional: 100,
    bank: 100,
    marketing: 100,
    pension: 100,
    other: 100,
};

export const VAT_DEFAULT: Record<TypeExpenseCategory, TypeVatRate | null> = {
    software: 22,
    hosting: 22,
    hardware: 22,
    phone: 22,
    training: 22,
    meals: 10,
    lodging: 10,
    transit: 10,
    taxi: 10,
    car: 22,
    representation: 22,
    office: 22,
    professional: 22,
    bank: 0,
    marketing: 22,
    pension: 0,
    other: 22,
};

export const TRACEABLE_CATEGORIES: TypeExpenseCategory[] = ['meals', 'lodging', 'taxi', 'representation'];

export const TRACEABILITY_FROM = '2025-06-18';

export const UNTRACEABLE_METHODS: TypeExpenseMethod[] = ['cash'];

export const INSTRUMENTAL_THRESHOLD_CENTS = 51_646;

export const REBILL_STALE_DAYS = 30;

export const RENEWAL_NOTICE_DAYS = 30;

export const DUE_SOON_DAYS = 7;

export const INTEGRATION_DAY_OF_MONTH = 15;

export const RECURRENCE_MONTHS: Record<TypeExpenseRecurrence, number> = {
    none: 0,
    monthly: 1,
    quarterly: 3,
    semiannual: 6,
    yearly: 12,
};

export const AUTO_PAID_METHODS: TypeExpenseMethod[] = ['card', 'sdd', 'paypal'];
